import cart from "./cartSlice";
import products from "./productSlice";
const rootReducer = {
  cart,
  products,
};

export default rootReducer;
